import React from 'react';
import { Flex } from 'rebass';
import { SearchInput } from '../../../../components/Form';
import PropTypes from 'prop-types';
import { isBrowser } from 'react-device-detect';
import { FilterBarProps } from '../../../../components/FilterBar/FilterBar';
import { rebassProps } from '../../../../theme/theme';
import ResetFiltersButton from '../../../../components/FilterBar/ResetFiltersButton';
import { getStringSearchPlaceholder } from '../../../../helpers/search';
import { searchFields } from './RecycledSites';

export type RecycledSiteFilters = {
  stringSearch?: string | undefined;
};

export const defaultFilters: RecycledSiteFilters = {
  stringSearch: undefined,
};

type FilterBarRecycledSitesProps = FilterBarProps<RecycledSiteFilters>;

const FilterBarRecycledSites: React.FC<FilterBarRecycledSitesProps> = (
  props
) => {
  const { filters, setFilters, selectedId } = props;

  const onChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    setFilters((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));
  };

  return (
    <Flex variant="filterBar.container" {...(props as rebassProps)}>
      <Flex variant="filterBar.left">
        <SearchInput
          placeholder={getStringSearchPlaceholder(searchFields)}
          autoFocus={isBrowser && !selectedId}
          width={300}
          name="stringSearch"
          value={filters.stringSearch === undefined ? '' : filters.stringSearch}
          onChange={onChange}
        />
      </Flex>
      <Flex variant="filterBar.right">
        <ResetFiltersButton setFilters={setFilters} />
      </Flex>
    </Flex>
  );
};

FilterBarRecycledSites.propTypes = {
  filters: PropTypes.any,
  setFilters: PropTypes.func.isRequired,
};

export default FilterBarRecycledSites;
